import photoMixin from "@/components/mixins/photoMixin";
import {getCookie, getJsonCookie, incrementNativeAdImpressionCount} from "@/core/utils/helpers/cookieHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";
import {RegionalExplicitEnum} from "@/core/constants/enums/regionalExplicitEnum";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {decodeRot13, encodeRot13} from "@/core/utils/helpers/textHelpers";
import {AdvertPlaceholder} from "@/core/constants/advertConstants";
import {generateImpressionId} from "@/core/utils/helpers/advertHelper";
import {pick} from "lodash/object";

function initializePhotoScroll() {
    if (typeof window !== 'undefined') {
        const photosData = this.getPhotosScrollData();
        const userPhotosCount = _.get(this, 'user.photos', []).length;

        if (userPhotosCount > photosData.photosPerView) {
            this.showScrollArrows = true;

            const carouselElement = $("#profile-image-slider");
            carouselElement.off('slide.bs.carousel').on('slide.bs.carousel', (event) => {
                this.scrollToImg(event.to + 1);
            });
        }
    }
}

function getPhotosScrollData() {
    const scrollElement = $('.carousel-indicators');
    const firstImage = $('.carousel-indicator-item-0');

    const totalHeight = scrollElement.prop('scrollHeight') - parseInt(firstImage.css('margin-top'));
    const imagesCount = _.get(this, 'user.photos', []).length;

    const imageHeight = totalHeight / imagesCount;
    const photosPerView = Math.round(scrollElement.height() / imageHeight);

    return {imageHeight, photosPerView}
}

function scrollToImg(targetIndex = 0) {
    if (typeof window !== 'undefined') {
        const photosData = this.getPhotosScrollData();

        if (photosData.imageHeight && photosData.photosPerView) {
            const firstImage = $('.carousel-indicator-item-0');

            if (targetIndex <= photosData.photosPerView) {
                firstImage.animate({'margin-top': 0}, 1000);
            } else {
                firstImage.animate(
                    {'margin-top': -(photosData.imageHeight * (targetIndex - photosData.photosPerView))}, 500);
            }
        }
    }
}

function carouselPrev() {
    $('#profile-image-slider').carousel('prev');
}

function carouselNext() {
    $([document.documentElement, document.body]).animate({
        scrollTop: 0,
    }, 500);
    $('#profile-image-slider').carousel('next');
}

function buildVideoIframeHtml(videoId) {
    const isMobile = $(window).width() < 576;

    return '<iframe' +
        '  src="' + process.env.MIX_CLOUDFARE_SUBDOMAIN + '/' + videoId + '/iframe"' +
        '  style="border: none"' +
        '  height="' + (isMobile ? 380 : 720) + '"' +
        '  width="' + (isMobile ? 500 : 1280) + '"' +
        '  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"' +
        '  class="profile-video-in-fancybox-iframe"' +
        '  allowfullscreen="true"' +
        '></iframe>';
}

/**
 * @see docs/ads/native-advert-click-url.md — Native Advert Click URL convention.
 * Keep param shape (action, label, sessionId, deviceId, country, category, attributes[impression_id])
 * and ROT13 placeholder swap consistent with `advertMixin#advertClickUrl`
 * and `NativeAdInSearchComponent#clickUrl`.
 */
function buildGalleryAdvertClickUrl(advert, impressionId) {
    try {
        if (!advert.clickurl) {
            return '#';
        }

        const url = new URL(atob(advert.clickurl));

        if (impressionId) {
            const toParam = url.searchParams.get('to');
            if (toParam) {
                const placeholderEncoded = encodeURIComponent(AdvertPlaceholder.CLICK_ID);
                const impressionIdEncoded = encodeURIComponent(impressionId);
                const replaced = decodeRot13(toParam).replace(placeholderEncoded, impressionIdEncoded);
                url.searchParams.set('to', encodeRot13(replaced));
            }
        }

        url.searchParams.append('action', 'native-ads-click');
        url.searchParams.append('label', advert.big_query_tag || 'eb-native-no-tag');
        url.searchParams.append('sessionId', getCookie(CookiesEnum.XTRACKING_DEVICE_ID));
        url.searchParams.append('deviceId', getCookie(CookiesEnum.XTRACKING_SESSION_ID));
        url.searchParams.append('category', 'profile-gallery');

        if (typeof cou !== 'undefined') {
            url.searchParams.append('country', cou);
        }

        if (impressionId) {
            url.searchParams.append('attributes[impression_id]', impressionId);
        }

        return url.toString();
    } catch (e) {
        return '#';
    }
}

function buildGalleryAdvertSlide(advert) {
    const impressionId = generateImpressionId();
    const clickUrl = buildGalleryAdvertClickUrl(advert, impressionId);

    const isMobile = $(window).width() < 576;
    const tagTitle = advert.tag_title || 'Anzeige';
    const textLine1 = (isMobile && advert.mobile_text_line_1) ? advert.mobile_text_line_1 : (advert.text_line_1 || '');
    const textLine2 = (isMobile && advert.mobile_text_line_2) ? advert.mobile_text_line_2 : (advert.text_line_2 || '');

    let removeCtaHtml = '';
    if (_.get(this, 'isPunter', false)) {
        const removeUrl = regionRelativeUrl('/users/products/punter-vip/');
        const removeText = _.get(this, 'translate.account.galleryAdRemoveCta', 'Want these removed?');
        removeCtaHtml = '<a class="gallery-ad-fullscreen__remove-cta" href="' + _.escape(removeUrl) + '">' + _.escape(removeText) + '</a>';
    }

    /**
     * Wrapper div with two sibling anchors: the ad link and the CTA link. Both have
     * native href + target attributes; FancyBox's swipe handler suppresses the
     * synthetic click event on mobile, so the touchend handler in `afterShow` does
     * the actual navigation for taps. Sibling structure avoids the invalid
     * <a> inside <a> nesting problem.
     */
    const html = '<div class="gallery-ad-fullscreen" data-advert-id="' + _.escape(advert.id) + '">'
        + '<a class="gallery-ad-fullscreen__media" href="' + _.escape(clickUrl) + '" target="_blank" rel="noopener noreferrer">'
        + '<div class="profile-block profile-block--native new-style-native-advert outline-gold">'
        + '<span class="profile-block-images loaded h-100">'
        + '<div class="native-girls-partner-tag">' + _.escape(tagTitle) + '</div>'
        + '<div class="native-girls-image" style="background-image: url(\'' + _.escape(advert.image_full_link) + '\')"></div>'
        + '</span>'
        + '<span class="profile-block-details">'
        + '<span class="user-details overflow-hidden">'
        + '<span class="heading-1 d-flex"><span class="text-ellipsis">' + _.escape(textLine1) + '</span></span>'
        + '<span class="user-details-location"><span class="text-ellipsis">' + _.escape(textLine2) + '</span></span>'
        + '</span>'
        + '</span>'
        + '</div>'
        + '</a>'
        + removeCtaHtml
        + '</div>';

    return {
        type: 'html',
        src: html,
        isAdvert: true,
        advertId: String(advert.id),
        impressionId,
        bigQueryTag: advert.big_query_tag || 'eb-native-no-tag',
        advertAttributes: pick(advert, ['id', 'image_full_link', 'link', 'text_line_1', 'text_line_2', 'mobile_text_line_1', 'tag_title']),
        opts: {slideClass: 'fancybox-slide--ad'},
    };
}

function showFancybox(rawIndex, user) {
    const $carouselElement = $("#profile-image-slider");
    $carouselElement.carousel('pause');

    const photos = [];
    const galleryAdverts = _.filter(_.get(user, 'galleryAdverts', []), 'image_full_link');
    const showAdverts = !this.isVipPunter && !_.isEmpty(galleryAdverts);
    const shuffledAdverts = showAdverts ? _.shuffle(_.clone(galleryAdverts)) : [];
    let advertsInjected = 0;
    let mediaSeen = 0;

    const pushAdvertAfterMedia = () => {
        if (!showAdverts || mediaSeen === 0 || mediaSeen % 5 !== 0) {
            return;
        }

        const advert = shuffledAdverts[advertsInjected % shuffledAdverts.length];
        photos.push(this.buildGalleryAdvertSlide(advert));
        advertsInjected += 1;
    };

    _.concat(user.photos, _.get(user, 'videos', [])).forEach((photo, index) => {
        if (this.isMediaExplicit(photo)) {
            photos.push({src: photo.video_id ? constants.user_photo.EXPLICIT_VIDEO_PLACEHOLDER : constants.user_photo.EXPLICIT_PHOTO_PLACEHOLDER});
            mediaSeen += 1;
            pushAdvertAfterMedia();
            return;
        }

        if (photo.video_id) {
            photos.push(buildVideoIframeHtml(photo.video_id));
        } else {
            let res = photo.resolution ? photo.resolution.split('x') : [];
            const hasWatermark = _.get(photo, `has_watermark`, false);

            let src = photo.galleryId
                ? photo.urls.default.jpg
                : this.getPhotoUrlByName(`${photo.name}${hasWatermark ? 'w' : ''}`, photo.user_id, 'jpg', 'original');

            // 520x692 is the highest upscaled version we have
            // we don't want to show original photos smaller than this
            if (res[0] && res[1] && res[0] < 520 && res[1] < 692) {
                // the `getPhotoUrlByName` method by default returns the 520x692 size
                src = photo.galleryId
                    ? photo.urls.default.jpg
                    : this.getPhotoUrlByName(`${photo.name}${hasWatermark ? 'w' : ''}`, photo.user_id, 'jpg');
            }

            photos.push({src: src});
        }

        mediaSeen += 1;

        const length = user.photos.length + _.get(user, 'videos.length', 0);
        if ((length > 2 && index === 1) || (length < 2 && index >= length - 1)) {
            /** adds "purchase private gallery" photo with button to gallery */
            document.querySelectorAll('.private-gallery-purchase').forEach(buyGalleryElement => {
                if (buyGalleryElement) {
                    let buyGalleryHtml = buyGalleryElement.innerHTML.replace(/<source.*?>/, '');
                    buyGalleryHtml = buyGalleryHtml.replace('<picture>', '');
                    buyGalleryHtml = buyGalleryHtml.replace('</picture>', '');
                    buyGalleryHtml = buyGalleryHtml.replace('<img', '<img width="520px" height="692px" style="visibility: hidden"');

                    buyGalleryHtml = '<div data-width="520" data-height="692"><div class="private-gallery-container">' + buyGalleryHtml + '</div></div>'
                    photos.push({type: 'inline', src: buyGalleryHtml})
                }
            })
        }

        pushAdvertAfterMedia();
    });

    if (showAdverts && mediaSeen > 0 && mediaSeen < 5) {
        photos.push(this.buildGalleryAdvertSlide(shuffledAdverts[0]));
    }

    const premiumOffset = (rawIndex > 1) ? _.get(this, 'showedGalleryCount', 0) : 0;
    const advertOffset = showAdverts ? Math.floor(rawIndex / 5) : 0;
    const slideIndex = rawIndex + premiumOffset + advertOffset;

    const seenAdvertImpressions = new Set();

    $.fancybox.open(photos, {
        loop: false,
        smallBtn: false,
        buttons: [
            'close',
            'zoom',
        ],
        afterShow: (fancybox, currentSlide) => {
            // Hide the loader when the slide is shown (especially for videos)
            $('.fancybox-loading').hide();

            if (!currentSlide || !currentSlide.isAdvert || !currentSlide.advertId) {
                return;
            }

            /**
             * FancyBox's touch handler calls preventDefault during swipe detection,
             * suppressing the synthetic click that would normally follow a tap.
             * Both anchors (ad media + remove CTA) need manual navigation in touchend.
             * Routing decision is made from the tap's target: which anchor it's inside.
             */
            const tapMaxDistance = 15;
            const tapMaxDuration = 800;
            const $content = currentSlide.$content;
            if ($content) {
                let touchStart = null;

                const navigateForTap = (target) => {
                    const $target = $(target);
                    const $cta = $target.closest('.gallery-ad-fullscreen__remove-cta');
                    if ($cta.length) {
                        const href = $cta.attr('href');
                        if (href) {
                            window.location.assign(href);
                        }
                        return;
                    }
                    const $media = $target.closest('.gallery-ad-fullscreen__media');
                    if ($media.length) {
                        const href = $media.attr('href');
                        if (href && href !== '#') {
                            window.open(href, '_blank', 'noopener,noreferrer');
                        }
                    }
                };

                $content.off('touchstart.galleryAdTap touchend.galleryAdTap click.galleryAdFallback')
                    .on('touchstart.galleryAdTap', (event) => {
                        const t = event.originalEvent.touches[0];
                        touchStart = {x: t.clientX, y: t.clientY, time: Date.now(), target: event.target};
                    })
                    .on('touchend.galleryAdTap', (event) => {
                        if (!touchStart) {
                            return;
                        }
                        const t = event.originalEvent.changedTouches[0];
                        const dx = Math.abs(t.clientX - touchStart.x);
                        const dy = Math.abs(t.clientY - touchStart.y);
                        const dt = Date.now() - touchStart.time;
                        const startTarget = touchStart.target;
                        touchStart = null;
                        if (dx > tapMaxDistance || dy > tapMaxDistance || dt > tapMaxDuration) {
                            return; // swipe / long press — let FancyBox handle it
                        }
                        navigateForTap(startTarget);
                    })
                    /**
                     * Desktop click fallback. Native anchors would normally navigate,
                     * but FancyBox may preventDefault on click; doing it explicitly
                     * is harmless if the native click also fires.
                     */
                    .on('click.galleryAdFallback', (event) => {
                        if (event.pointerType === 'touch') {
                            return; // touchend already handled it
                        }
                        if (event.originalEvent && event.originalEvent.detail === 0) {
                            return; // synthetic / programmatic click — skip
                        }
                        navigateForTap(event.target);
                    });
            }

            const advertId = currentSlide.advertId;

            if (seenAdvertImpressions.has(advertId)) {
                return;
            }

            seenAdvertImpressions.add(advertId);
            const nativeImpressionCount = incrementNativeAdImpressionCount();
            this.captureTrackingEvent(this.currentUser, 'profile-gallery', 'native-ads-impression', currentSlide.bigQueryTag, null, {
                impression_id: currentSlide.impressionId,
                native_impression_count: nativeImpressionCount,
                ...(currentSlide.advertAttributes || {}),
            });
        },
        afterClose: () => {
            $carouselElement.carousel('cycle');
            if (window.location.href.indexOf('#gallery') !== -1) {
                window.history.back();
            }
        },
    }, slideIndex);


    window.location = '#gallery';

    setTimeout(() => {
        window.onhashchange = () => {
            if (window.location.href.indexOf('#gallery') === -1) {
                $.fancybox.getInstance('close');
            }
        };
    });
}

function showAllProfilePhotos() {
    this.showAllPhotos = true;
    setTimeout(() => {
        // The type check should solve the `$(...).carousel is not a function` error
        // which happened on the "Fast 3G" connections (not always)
        // The carousel itself still was functioning after the full page load.
        //
        // The timeout initiation indicates that this was known issue before as well.
        if (typeof $('.carousel').carousel !== 'undefined') {
            $('.carousel').carousel();
        }
    }, this.carouselLoadAfterInterval)
}

/**
 * @param photoOrVideo
 * @returns {boolean}
 */
function isMediaExplicit(photoOrVideo) {
    if (this.isGalleryPurchasedByGuest()) {
        return false;
    }

    if (photoOrVideo.video_id) {
        return this.videoIsExplicit(photoOrVideo)
    }

    return this.photoIsExplicit(photoOrVideo);
}

function isGalleryPurchasedByGuest() {
    const purchasedGalleries = getJsonCookie(CookiesEnum.PURCHASED_GUEST_GALLERIES);

    if (purchasedGalleries && Array.isArray(purchasedGalleries)) {
        const galleryId = _.get(this, 'user.galleries.0.id')
        const userHaveCodeForProfilePrivateGallery = galleryId && purchasedGalleries.find(item => item.galleryId === galleryId);

        if (userHaveCodeForProfilePrivateGallery) {
            return true;
        }
    }

    return false;
}

/**
 * @returns {boolean}
 */
function isAgeVerifiedVipPunter() {
    return this.isAgeVerified && this.isVipPunter;
}

/**
 *
 * @param video
 * @returns {boolean}
 */
function videoIsExplicit(video) {
    if (this.isAgeVerifiedVipPunter()) {
        return false;
    }

    return _.get(video, 'is_explicit', false);
}

/**
 *
 * @returns {boolean}
 */
async function fetchGalleryAdverts() {
    const userId = _.get(this, 'user.id');
    if (this.isVipPunter || !userId) {
        return;
    }

    const mediaCount = _.get(this, 'user.photos.length', 0) + _.get(this, 'user.videos.length', 0);
    if (mediaCount === 0) {
        return;
    }

    const count = Math.max(1, Math.floor(mediaCount / 5));

    const [err, response] = await to(api.galleryAdverts.list(userId, count));
    if (err || !response || !this.user) {
        return;
    }

    this.$set(this.user, 'galleryAdverts', _.get(response, 'data', []));
}

function photoIsExplicit(photo) {
    const allowedExplicitMedia = _.isEqual(_.get(this, 'currentUser.allowed_explicit_photo', null), this.user.id);
    if (this.isAgeVerifiedVipPunter() || allowedExplicitMedia) {
        return false;
    }

    const photoRegionalExplicit = _.get(photo, 'regional_explicit', RegionalExplicitEnum.NO);

    if ((photoRegionalExplicit === RegionalExplicitEnum.YES || photoRegionalExplicit === RegionalExplicitEnum.ERROR) && this.userIsFromExplicitRegion) {
        return true;
    }

    return _.get(photo, 'explicit', false);
}

export default {
    data() {
        return {
            store: $store,
            moment: moment,
            showAllPhotos: false,
            fancyboxIndex: null,
        }
    },
    computed: {
        ...mapState({
            isSeekingServicesProfile: 'isSeekingServicesProfile',
            currentUser: 'currentUser',
            translate: 'translate',
            isVenueProfilePhoto: 'venue',
            userIsFromExplicitRegion: 'userIsFromExplicitRegion',
        }),
        photosToShow() {
            const photos = _.get(this, 'user.photos', []);
            const videos = _.get(this, 'user.videos', []);
            if (this.showAllPhotos) {
                return _.concat(photos, videos);
            }
            return _.slice(_.concat(photos, videos), 0, 1);
        },
    },
    mixins: [photoMixin],
    watch: {
        'user.id': {
            immediate: true,
            handler(newId) {
                if (!newId) {
                    return;
                }
                this.fetchGalleryAdverts();
            },
        },
    },
    methods: {
        initializePhotoScroll,
        getPhotosScrollData,
        scrollToImg,
        carouselPrev,
        carouselNext,
        showFancybox,
        buildVideoIframeHtml,
        buildGalleryAdvertSlide,
        fetchGalleryAdverts,
        showAllProfilePhotos,
        isMediaExplicit,
        isAgeVerifiedVipPunter,
        videoIsExplicit,
        photoIsExplicit,
        isGalleryPurchasedByGuest,
    },
}
